import { render, staticRenderFns } from "./yyzz.vue?vue&type=template&id=3fe936bb&scoped=true"
import script from "./yyzz.vue?vue&type=script&lang=js"
export * from "./yyzz.vue?vue&type=script&lang=js"
import style0 from "./yyzz.vue?vue&type=style&index=0&id=3fe936bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe936bb",
  null
  
)

export default component.exports